module.exports = __webpack_public_path__ + "images/stickers/clock@2x.b678287abafc2d8c99f3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/clock@2x.png
// module id = jdQr
// module chunks = 1